export default {
  namespaced: true,
  state: {
    isMobile: false,
    theme: 'dark',
    layout: 'side',
    systemName: '',
    copyright: '',
    footerLinks: [{ link: 'http://santiagoweb.com.ar/', name: 'SantiagoWeb' }],
    multipage: false,
    crearMat1: [],
    crearMat2: [],
    crearMat3: [],
    matActual: null
  },
  mutations: {
    setDevice (state, isMobile) {
      state.isMobile = isMobile
    },
    setTheme (state, theme) {
      state.theme = theme
    },
    setLayout (state, layout) {
      state.layout = layout
    },
    setMultipage (state, multipage) {
      state.multipage = multipage
    },
    setCrearMat1 (state, crearMat1) {
      state.crearMat1 = crearMat1
    },
    setCrearMat2 (state, crearMat2) {
      state.crearMat2 = crearMat2
    },
    setCrearMat3 (state, crearMat3) {
      state.crearMat3 = crearMat3
    },
    setMatActual (state, matActual) {
      state.matActual = matActual
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js